import { useCallback, useMemo } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { isEmpty } from 'lodash'

import { updateComplexNo, fetchMyHouseAuth } from '@Root/slices/myhouse/myhouse'
import { RootState } from '@Root/slices'
import { FETCH_STATUS } from '@Root/contants'

export default function useMyhouse() {
  const dispatch = useDispatch()
  const myhouse = useSelector((state: RootState) => state.myhouse)

  const setComplexNo = useCallback(
    (value: number) => {
      dispatch(updateComplexNo(value))
    },
    [dispatch],
  )

  const loadMyHouseAuth = useCallback(() => {
    dispatch(fetchMyHouseAuth())
  }, [dispatch])

  const isLoaded = useMemo(() => myhouse.fetchStatus === FETCH_STATUS.SUCCESS || myhouse.fetchStatus === FETCH_STATUS.FAILURE, [myhouse.fetchStatus])

  const isRegistrationExists = useMemo(() => !isEmpty(myhouse.authHouseNoMap), [myhouse.fetchStatus])

  return {
    myhouse,
    setComplexNo,
    loadMyHouseAuth,
    isLoaded,
    isRegistrationExists,
  }
}
